<template>
<div id="app">
    <navigation />
    <vodafoneads v-if="adsvisible" />
    <transition name="component-fade" mode="out-in">
        <component v-bind:is="currentComponent" />
    </transition>
    <sitefooter />
</div>
</template>

<script>

import Vue from 'vue'

Vue.component('navigation', require('./components/Navigation.vue').default);
Vue.component('startseite', require('./components/startseite.vue').default);
Vue.component('ouroffices', require('./components/ouroffices.vue').default);
Vue.component('contact', require('./components/contact.vue').default);
Vue.component('vodafoneads', require('./components/vodafone_ad.vue').default);
Vue.component('angebote', require('./components/angebote.vue').default);
Vue.component('sitefooter', require('./components/footer.vue').default);
Vue.component('impressum', require('./components/impressum.vue').default);
Vue.component('datenschutzerklaerung', require('./components/datenschutz.vue').default);

export default {
    name: 'app',
    data() {
        return {
            currentComponent: 'startseite',
            adsvisible: true
        }
    },
    methods: {
        changeToImmoScout() {
            this.currentComponent = 'angebote'
            this.adsvisible = true
        },
        changeToOffice() {
            this.currentComponent = 'ouroffices'
            this.adsvisible = false
        },
        changeToStart() {
            this.currentComponent = 'startseite'
            this.adsvisible = true
        },
        changeToContact() {
            this.currentComponent = 'contact'
            this.adsvisible = true
        },
        changeToImpressum() {
            this.currentComponent = 'impressum'
            this.adsvisible = false
        },
        changeToDatenschutz() {
            this.currentComponent = 'datenschutzerklaerung'
            this.adsvisible = false
        }
    }
}
</script>

<style lang="scss">
@import "~bootstrap/dist/css/bootstrap.css";
@import "vue-select/src/scss/vue-select.scss";
@import "~leaflet/dist/leaflet.css";

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity .5s ease;
}

.component-fade-enter,
.component-fade-leave-to

/* .component-fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
}

@keyframes animation {
    0% {
        transform: scaleY(0.3);
    }

    100% {
        transform: scaleY(1);
    }
}
</style>
